import { useAdminContextStore } from '@/store/adminContext';

/**
 * Hook for AdminFacilitySelector.
 * Backed by a persisted Zustand store so the selection survives navigation.
 */
export function useAdminFacility() {
  const selectedFacility = useAdminContextStore((s) => s.selectedFacilityId);
  const setSelectedFacility = useAdminContextStore((s) => s.setSelectedFacilityId);

  return { selectedFacility, setSelectedFacility };
}
